/** 多资源列表（gallery 的 images 等）：每项一个 AssetInput，可增删。 */
import { Button, Space } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { AssetInput } from './AssetInput';

interface Props { value: unknown; onChange(v: string[]): void; accept: string }

export function MultiAssetInput({ value, onChange, accept }: Props) {
  const list: string[] = Array.isArray(value) ? (value as string[]) : [];
  const update = (i: number, v: string) => onChange(list.map((s, j) => (j === i ? v : s)));
  const remove = (i: number) => onChange(list.filter((_, j) => j !== i));
  return (
    <Space direction="vertical" style={{ width: '100%' }} size={6}>
      {list.map((src, i) => (
        <div key={i} style={{ display: 'flex', gap: 4, alignItems: 'flex-start' }}>
          <div style={{ flex: 1 }}><AssetInput value={src} accept={accept} preview={accept.startsWith('image') ? 'image' : 'none'} onChange={(v) => update(i, v)} /></div>
          <Button size="small" danger type="text" icon={<DeleteOutlined />} onClick={() => remove(i)} />
        </div>
      ))}
      <Button block size="small" icon={<PlusOutlined />} onClick={() => onChange([...list, ''])}>添加</Button>
    </Space>
  );
}
